import { http } from '@/_services/http.service'

export const registrationService = {

  getSummary(){

    const options = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/user/steps/summary`, options)
            .then(response => response.json())
  },

  getPreferences(){

    const options = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/user/steps/preferences`, options)
            .then(response => response.json())
  },

  getPaymentInfo(){

    const options = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/user/steps/payment`, options)
            .then(response => response.json())
  },

  getPaymentLink(type){
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 'type': type })
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/user/steps/payment`, options)
            .then(response => response.json())
  },

  stopRecuringPayment(){
    const options = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/user/steps/payment/recurring`, options)
            .then(response => response.json())
  },

  getFamily(){

    const options = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/user/steps/family`, options)
            .then(response => response.json())
  },

  getSituation(){

    const options = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/user/steps/situation`, options)
            .then(response => response.json())
  },

  postSituation(data){
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/user/steps/situation`, options)
            .then(response => response.json())
  },

  postPreferences(data){
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/user/steps/preferences`, options)
            .then(response => response.json())
  },

  postFamily(extraPeople){
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ people: extraPeople})
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/user/steps/family`, options)
            .then(response => response.json())
  },

  findPartnerRegistration(data){
    const options = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    }

    let url = `${process.env.VUE_APP_API_URL}/user/steps/partner/existing&` + new URLSearchParams(data)

    return http.fetch(url, options)
  },

  requestPartnerConnection(guid){
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ partner: guid})
    }

    let url = `${process.env.VUE_APP_API_URL}/user/steps/partner/existing`

    return http.fetch(url, options)
  },

  confirmPartnerConnection(code){
    const options = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ confirmationcode: code})

    }

    let url = `${process.env.VUE_APP_API_URL}/user/steps/partner/existing`

    return http.fetch(url, options)
  },
  getState() {
    const options = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/user/state`, options)
        .then(response => response.json())
  },
  getWN() {
    const options = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    }

    return http.fetch(`${process.env.VUE_APP_API_URL}/mra/connect`, options)
        .then(response => response.json())
  },
  postWN(wnUsername) {
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ wnUsername })
    }

    let url = `${process.env.VUE_APP_API_URL}/mra/connect`

    return http.fetch(url, options)
  },

  putWN(oldnumber) {
    const options = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ oldnumber })
    }

    let url = `${process.env.VUE_APP_API_URL}/user/steps/wn`

    return http.fetch(url, options)
  },
  postPrivacy() {
    const options = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({})
    }

    let url = `${process.env.VUE_APP_API_URL}/user/steps/privacy`

    return http.fetch(url, options)
  }
}
